
var iframe_pdf

function setCookie2(name, value, expiracy) {
    var exDate = new Date();    
    exDate.setTime(exDate.getTime() + expiracy * 1000);
    var c_value = escape(value) + ((expiracy == null) ? "" : "; expires=" + exDate.toUTCString());   
    document.cookie = name + "=" + c_value + '; path=/';
}

function getCookie2(name) {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == name) {
            return y ? decodeURI(unescape(y.replace(/\+/g, ' '))) : y; //;//unescape(decodeURI(y));
        }
    }
}

function checkIframeLoaded(iframe) {
    const checkInterval = setInterval(() => {
        if (getCookie2("downloadStarted") == "1") {
            setCookie2("downloadStarted", "0", 100);
            $(".loading-overlay").hide(); 
                clearInterval(checkInterval);
        }    
    }, 500);
}

function printTrip(rid) {
    setTripDetailClean()
    $(".loader-gif-waiting").attr("src","/dist/images/loader-trans.gif");
    $(".loading-overlay").show();                                                                           
    iframe_pdf = document.createElement('iframe');
    iframe_pdf.src ='/client/print.aspx?rid=' + rid;
    document.body.appendChild(iframe_pdf);
    checkIframeLoaded(iframe_pdf);
}


$(function () {

    $('.close-loading-overlay').on('click',function (e){ 
        e.preventDefault();  
        $(".loading-overlay").hide();                                                                                                                                                                                                 
    })
  
    //create new trip
    $('.jq-create-new-trip').on('click',function (e){ 
        e.preventDefault();  
        showModal({ url: "/widgets/Trip/Trip-Detail.aspx?m=1", saveText: "Save Trip", title: "Create Trip",
            callback: function (modal) {saveTripDetail(modal, function(modal,rid,tripName){  
                showSystemNotification("Trip '" + tripName + "' has been created.  You are being redirected to the new trip page.");
                window.location.href="/Trip/?rid=" + rid;
            })}
        }) ;          
    })

    $('.btn-trip-print').on('click',function (e){ 
        e.preventDefault();  
        printTrip(getTripDetailRID());
        return false;
    })
     
    $(document).on('click', '#createTripTraveler', function (e) {
        e.preventDefault();
        showModal({ url: "/widgets/Traveler/Traveler-New.aspx", saveText: "Save New Traveler", title: "New Traveler", callback:  function (modal) {saveTravelerDetail(modal,onNewTravelerTrip)}}) ;
    })

});

function getSelectedTravelers(ele) { 
    var ids="";
    var itms=  $('#' + ele).select2('data'); 
    itms.forEach((itm) => {ids+=itm.id + ","});  
    return ids;
}

function saveTripDetail(modal,callback) {
                                            
    if (editall_trip()) { 
        Page_Blur(true);
        var e = $(this); var req = new Object;
        req.ReportID = $("#hdnReportID").val();
        req.Mode = $("#hdnMode").val();
        req.UserClientKey = $("#cboTripClient").val() == "" ? "0" : $("#cboTripClient").val();
        req.StartDate = $("#txtTripDetailDepartureDate").val();
        req.EndDate = $("#txtTripDetailReturnDate").val();
        req.TripName = $("#txtTripName").val();
        req.PreparedFor = $("#txtTripDetailPreparedFor").val();
        req.Travelers = getSelectedTravelers("drpTravelers")
        req.TripPrice = $("#txtTripDetailPrice").val();
        req.TripComments = $("#txtTripDetailComments").val();
        req.TripDescription = $("#txtTripDetailNotes").val();
        req.IncludeCover = $("#chkTripDetailShowCoverPage").prop("checked");
        req.IncludeTOC = $("#chkTripDetailShowTripSummary").prop("checked");
        req.IncludeBizCard = $("#chkTripDetailIncludeBizCard").prop("checked");
        req.ShowImagesOnlineView = $("#chkTripDetailShowImagesOnlineView").prop("checked");
        req.ShowImagesPDFView = $("#chkTripDetailShowImagesPDFView").prop("checked");   
        req.ExternalLinkImage     =$("#txtTripDetailImageURL").val();
        req.SuppressDefaultImage  =$("#chkSuppressDefaultImage").prop("checked");       
        req.TripImageFile =  $("#hdnImageName").val() 

        var DTO = { 'Req': req }
        DynaProxy.invoke("SaveTrip", DTO, function (data) {                   
           
            setEditClean()
            if( typeof callback == "function" )  {
                callback(modal,data,req.TripName);       
            }
            else{      
                if (window.location.href.indexOf('/Trip/Preview.aspx')  > -1) { window.location.reload();}
                $(".trip-detail-name").html(req.TripName)
                refrehTripList(false);                      
                closeModal(modal);   
                showSystemNotification("Trip '" + req.TripName + "' has been saved");  
            } 
        }, function (data) {
            showSupportNotification('Unable to save trip.'); 
        })
        return true;
    } else {
        return false;
    }

}

function saveCustomPlace(modal,callback) {

        if ($("#txtName").val() == "") { alert('Please enter a Name'); return false; }

        Page_Blur(true);
        var req = new Object;
        req.ReportID = $("#hdnReportID").val(); 
        req.ID = $("#hdnP").val();
        req.Type = $("#cboType").val();
        req.Name = $("#txtName").val()
        req.Address = $("#txtAddress").val()
        req.Phone = $("#txtPhone").val()
        req.URL = $("#txtWebsite").val()
        req.Description = editor.getSemanticHTML();
        req.Latitude = -999; req.Longitude = -999; req.Image = ""
        var DTO = { 'Req': req };

        DynaProxy.invoke("UpdateCustomPlaceOption", DTO, function (data) {                   
           
            if( typeof callback == "function" )  {
                callback(modal,data,req.Name);       
            }
            else{           
                closeModal(modal);                                                              
                showSystemNotification("Custom Place '" + req.Name + "' has been added to your trip and we are refreshing the page.");  
                Page_Blur(true);
                refreshWithQueryParam("tab","CUST");       
            } 
        }, function (data) {
            showSupportNotification('Unable to save Custom Place.');  
        })
        return true;
 
    }

function editall_trip() {
    if ($("#txtTripName").val() == "") {
        showSystemNotification('Trip Name is required')
        $("#txtTripName").focus() 
        return false
    }
    
    var sDate1 = $("#txtTripDetailDepartureDate").val()
    var sDate2 = $("#txtTripDetailReturnDate").val()
    var dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (sDate1!=""){
        if (!dateRegex.test(sDate1)) {
            showSystemNotification('Travel Date From must be a valid date')
            $("#txtTripDetailDepartureDate").focus() 
            return false
        }
    }
    if (sDate2 != "") {
        if (!dateRegex.test(sDate2)) {
            $("#txtTripDetailReturnDate").focus() 
            showSystemNotification('Travel Date To must be a valid date')
            return false
        }
    }
                
    return true;
}


function sendTrip() {
    if (editall_send()) {   
        Page_Blur(true)
        var req = new Object;
        req.ReportID = $("#hdnReportID").val().replace(/ /g, '')
        req.PlaceKey = $("#hdnPlaceKey").val()
        req.PlaceType = $("#hdnPlaceType").val()
        req.PlaceID = $("#hdnPlaceID").val()
        req.ClientIDs = getSelectedTravelers("drpTravelers")
        req.Subject = $("#txtSubject").val()
        req.Message = editor.getSemanticHTML();
        req.CopyUser = $("#chkCopy").prop('checked')
        var DTO = { 'Req': req }
        
        DynaProxy.invoke("SendTrip", DTO, function (data) {  
            Page_Blur(false)
            var s=data;
            if (s.indexOf("-")==0){
                s=s.replace("-3","") ;
                if (s.length>2){
                    showSupportNotification(s); 
                }else{
                    showSupportNotification('Unable to send report.');  
                }
            }
            else{  //success
                setTripDetailClean();
                refrehTripList(false); 
                showSystemNotification(data);
            }
        }, function (data) {
            Page_Blur(false)
            showSupportNotification('Unable to send report.');  
        })

        return true;
    } else{
        return false;
    }
}

function editall_send() {
    if (getSelectedTravelers("drpTravelers")=="") {
        showSystemNotification('Please select at least one traveler to send the trip to')
        $("#txtClient").focus()
        return false
    }

    if ($("#txtSubject").val() == "") {
        showSystemNotification('Subject is required')
        $("#txtSubject").focus() 
        return false
    }

    return true;
}

function saveTripItemComments(modal, callback) {
    Page_Blur(true);

    var req = new Object; 
    req.ReportID = $("#txtTripItemComment").data("rid")
    req.PlaceID = $("#txtTripItemComment").data("riid")
    req.Comment = $("#txtTripItemComment").val()
    var DTO = { 'Req': req }
    DynaProxy.invoke("SaveTripItemComment", DTO, function (data) {                   
           
        if( typeof callback == "function" )  {
            callback(modal,data,req.Comment);       
        }
        else{           
            closeModal(modal);  
            // Find elements with a specific data attribute and value

            var cmt=$('[data-riid="' + req.PlaceID + '"]').find(".btn-trip-item-comment");  
            if (cmt.length>0){
                if (req.Comment==""){
                    $(cmt).find("i").removeClass ("has-comment") ;
                }
                else{
                    $(cmt).find("i").addClass ("has-comment");
                }
                curcmt= null ; 
            }
            showSystemNotification("Comment has been saved.");  
        } 
    }, function (data) {
        showSupportNotification('Unable to save trip item comments');  
    })
    return true;
}

